var _g, _g2, _rect, _rect2, _rect3, _g3, _rect4, _rect5, _g4, _rect6, _rect7, _rect8, _g5, _rect9, _rect10, _g6, _rect11, _rect12, _rect13, _g7, _rect14, _rect15, _path, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodatayet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1_21716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.559 146.558C150.572 142.545 153.756 137.781 155.927 132.537C158.099 127.294 159.217 121.674 159.217 115.999C159.217 110.324 158.099 104.704 155.927 99.4606C153.756 94.2172 150.572 89.453 146.559 85.4399C142.546 81.4269 137.782 78.2435 132.538 76.0717C127.295 73.8998 121.675 72.782 116 72.782C110.325 72.782 104.705 73.8998 99.4615 76.0717C94.2182 78.2435 89.454 81.4269 85.4409 85.44L116 115.999L146.559 146.558Z",
    fill: "#FFDF6F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_1_21716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4409 85.4399C81.4278 89.453 78.2445 94.2172 76.0726 99.4605C73.9008 104.704 72.7829 110.324 72.7829 115.999C72.7829 121.674 73.9008 127.294 76.0726 132.537C78.2445 137.781 81.4278 142.545 85.4409 146.558C89.454 150.571 94.2182 153.755 99.4615 155.926C104.705 158.098 110.325 159.216 116 159.216C121.675 159.216 127.295 158.098 132.538 155.926C137.782 153.755 142.546 150.571 146.559 146.558L116 115.999L85.4409 85.4399Z",
    fill: "#FFA800"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.918,
    y: 143.244,
    width: 109.718,
    height: 40.5,
    rx: 10,
    fill: "#1D2025"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 85.8086,
    y: 149.135,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_21716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 149,
    width: 30,
    height: 29
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8086,
    y: 149.135,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#ECEEF0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_21716)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M78.4453 179.325L91.6866 158.411C92.0525 157.833 92.8776 157.785 93.3083 158.316L103.148 170.456C103.532 170.929 104.245 170.953 104.659 170.506L109.953 164.792C110.392 164.318 111.159 164.379 111.518 164.916L121.154 179.325H78.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M107.162 156.866C107.162 157.522 106.968 158.162 106.604 158.707C106.24 159.252 105.722 159.677 105.117 159.928C104.511 160.179 103.845 160.244 103.202 160.116C102.56 159.988 101.969 159.673 101.506 159.209C101.042 158.746 100.727 158.156 100.599 157.513C100.471 156.87 100.537 156.204 100.787 155.598C101.038 154.993 101.463 154.475 102.008 154.111C102.553 153.747 103.193 153.553 103.849 153.553C104.728 153.553 105.57 153.902 106.192 154.523C106.813 155.145 107.162 155.988 107.162 156.866Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 124.836,
    y: 157.234,
    width: 32.4,
    height: 2.94545,
    rx: 1.47272,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 124.836,
    y: 166.809,
    width: 32.4,
    height: 2.94545,
    rx: 1.47272,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.77 157.648C173.046 157.096 173.828 157.119 174.081 157.648L175.6 160.708L178.96 161.192C179.558 161.284 179.788 162.02 179.351 162.457L176.935 164.827L177.51 168.164C177.602 168.762 176.958 169.223 176.429 168.946L173.437 167.359L170.423 168.946C169.893 169.223 169.249 168.762 169.341 168.164L169.916 164.827L167.5 162.457C167.063 162.02 167.293 161.284 167.891 161.192L171.274 160.708L172.77 157.648Z",
    fill: "#797F8A"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.918,
    y: 47.5176,
    width: 109.718,
    height: 40.5,
    rx: 10,
    fill: "#1D2025"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 85.8086,
    y: 53.4082,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_21716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 53,
    width: 30,
    height: 30
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8086,
    y: 53.4082,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#ECEEF0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_21716)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M78.4453 83.5987L91.6866 62.6844C92.0525 62.1064 92.8776 62.0582 93.3083 62.5896L103.148 74.7295C103.532 75.2023 104.245 75.226 104.659 74.7794L109.953 69.0654C110.392 68.5915 111.159 68.6521 111.518 69.1892L121.154 83.5987H78.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M107.162 61.1398C107.162 61.7952 106.968 62.4359 106.604 62.9808C106.24 63.5257 105.722 63.9504 105.117 64.2012C104.511 64.452 103.845 64.5176 103.202 64.3898C102.56 64.2619 101.969 63.9463 101.506 63.4829C101.042 63.0195 100.727 62.4291 100.599 61.7863C100.471 61.1435 100.537 60.4772 100.787 59.8717C101.038 59.2662 101.463 58.7487 102.008 58.3846C102.553 58.0205 103.193 57.8262 103.849 57.8262C104.728 57.8262 105.57 58.1753 106.192 58.7967C106.813 59.4181 107.162 60.261 107.162 61.1398Z",
    fill: "white"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 124.836,
    y: 61.5078,
    width: 32.4,
    height: 2.94546,
    rx: 1.47273,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 124.836,
    y: 71.082,
    width: 32.4,
    height: 2.94545,
    rx: 1.47273,
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.77 61.9212C173.046 61.369 173.828 61.392 174.081 61.9212L175.6 64.9818L178.96 65.465C179.558 65.557 179.788 66.2934 179.351 66.7306L176.935 69.1008L177.51 72.4374C177.602 73.0357 176.958 73.496 176.429 73.2198L173.437 71.632L170.423 73.2198C169.893 73.496 169.249 73.0357 169.341 72.4374L169.916 69.1008L167.5 66.7306C167.063 66.2934 167.293 65.557 167.891 65.465L171.274 64.9818L172.77 61.9212Z",
    fill: "#797F8A"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1016,
    y: 95.3809,
    width: 109.718,
    height: 40.5,
    rx: 10,
    fill: "#1D2025"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 48.9922,
    y: 101.271,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_21716",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 101,
    width: 30,
    height: 29
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9922,
    y: 101.271,
    width: 28.7182,
    height: 28.7182,
    rx: 6,
    fill: "#ECEEF0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_21716)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M41.6289 131.462L54.8702 110.548C55.2361 109.97 56.0612 109.922 56.4919 110.453L66.3319 122.593C66.7152 123.066 67.4286 123.089 67.8423 122.643L73.137 116.929C73.5761 116.455 74.3426 116.515 74.7017 117.052L84.338 131.462H41.6289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M70.346 109.003C70.346 109.658 70.1517 110.299 69.7876 110.844C69.4235 111.389 68.906 111.814 68.3005 112.064C67.695 112.315 67.0287 112.381 66.3859 112.253C65.7431 112.125 65.1527 111.81 64.6893 111.346C64.2259 110.883 63.9103 110.292 63.7824 109.65C63.6546 109.007 63.7202 108.34 63.971 107.735C64.2218 107.13 64.6465 106.612 65.1914 106.248C65.7364 105.884 66.377 105.689 67.0324 105.689C67.9112 105.689 68.7541 106.039 69.3755 106.66C69.9969 107.281 70.346 108.124 70.346 109.003Z",
    fill: "white"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 88.0195,
    y: 109.371,
    width: 32.4,
    height: 2.94546,
    rx: 1.47273,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 88.0195,
    y: 118.945,
    width: 32.4,
    height: 2.94545,
    rx: 1.47272,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.953 109.785C136.229 109.232 137.012 109.255 137.265 109.785L138.784 112.845L142.143 113.328C142.742 113.42 142.972 114.157 142.535 114.594L140.118 116.964L140.694 120.301C140.786 120.899 140.141 121.359 139.612 121.083L136.621 119.495L133.606 121.083C133.077 121.359 132.433 120.899 132.525 120.301L133.1 116.964L130.684 114.594C130.247 114.157 130.477 113.42 131.075 113.328L134.458 112.845L135.953 109.785Z",
    fill: "#FAC402"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_21716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.759 133.93C142.501 133.598 142.179 132.926 141.617 132.089C141.295 131.628 140.504 130.754 140.264 130.303C140.092 130.029 140.042 129.695 140.126 129.383C140.271 128.788 140.834 128.394 141.442 128.462C141.913 128.557 142.345 128.787 142.685 129.125C142.923 129.349 143.141 129.592 143.339 129.852C143.486 130.036 143.523 130.11 143.688 130.321C143.854 130.533 143.964 130.745 143.882 130.432C143.817 129.972 143.707 129.198 143.55 128.508C143.431 127.983 143.403 127.901 143.292 127.505C143.182 127.109 143.118 126.778 142.998 126.327C142.889 125.883 142.803 125.435 142.74 124.983C142.624 124.404 142.709 123.804 142.98 123.28C143.301 122.977 143.773 122.898 144.176 123.077C144.582 123.377 144.884 123.795 145.041 124.274C145.283 124.863 145.444 125.483 145.52 126.115C145.667 127.035 145.953 128.379 145.962 128.655C145.962 128.315 145.897 127.597 145.962 127.275C146.026 126.939 146.259 126.66 146.579 126.538C146.853 126.454 147.143 126.435 147.425 126.483C147.711 126.543 147.963 126.707 148.134 126.943C148.347 127.48 148.466 128.05 148.484 128.628C148.509 128.122 148.595 127.621 148.742 127.137C148.895 126.92 149.12 126.764 149.377 126.695C149.681 126.639 149.993 126.639 150.297 126.695C150.547 126.778 150.765 126.936 150.923 127.146C151.118 127.634 151.236 128.149 151.273 128.674C151.273 128.803 151.337 128.315 151.54 127.993C151.645 127.68 151.909 127.448 152.232 127.383C152.555 127.318 152.889 127.43 153.106 127.677C153.324 127.925 153.394 128.269 153.289 128.582C153.289 129.18 153.289 129.152 153.289 129.557C153.289 129.962 153.289 130.321 153.289 130.662C153.255 131.201 153.181 131.736 153.068 132.264C152.908 132.73 152.685 133.173 152.405 133.58C151.958 134.077 151.589 134.638 151.31 135.246C151.24 135.548 151.209 135.857 151.218 136.166C151.217 136.452 151.254 136.737 151.328 137.013C150.952 137.053 150.572 137.053 150.196 137.013C149.837 136.958 149.395 136.24 149.275 136.019C149.216 135.9 149.095 135.825 148.962 135.825C148.83 135.825 148.709 135.9 148.65 136.019C148.447 136.369 147.996 137.004 147.683 137.041C147.066 137.114 145.796 137.041 144.793 137.041C144.793 137.041 144.959 136.12 144.581 135.789C144.204 135.458 143.817 135.071 143.532 134.813L142.759 133.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.759 133.93C142.501 133.598 142.179 132.926 141.617 132.089C141.295 131.628 140.504 130.754 140.264 130.303C140.092 130.029 140.042 129.695 140.126 129.383C140.271 128.788 140.834 128.394 141.442 128.462C141.913 128.557 142.345 128.787 142.685 129.125C142.923 129.349 143.141 129.592 143.339 129.852C143.486 130.036 143.523 130.11 143.688 130.321C143.854 130.533 143.964 130.745 143.882 130.432C143.817 129.972 143.707 129.198 143.55 128.508C143.431 127.983 143.403 127.901 143.292 127.505C143.182 127.109 143.118 126.778 142.998 126.327C142.889 125.883 142.803 125.435 142.74 124.983C142.624 124.404 142.709 123.804 142.98 123.28C143.301 122.977 143.773 122.898 144.176 123.077C144.582 123.377 144.884 123.795 145.041 124.274C145.283 124.863 145.444 125.483 145.52 126.115C145.667 127.035 145.953 128.379 145.962 128.655C145.962 128.315 145.897 127.597 145.962 127.275C146.026 126.939 146.259 126.66 146.579 126.538C146.853 126.454 147.143 126.435 147.425 126.483C147.711 126.543 147.963 126.707 148.134 126.943C148.347 127.48 148.466 128.05 148.484 128.628C148.509 128.122 148.595 127.621 148.742 127.137C148.895 126.92 149.12 126.764 149.377 126.695C149.681 126.639 149.993 126.639 150.297 126.695C150.547 126.778 150.765 126.936 150.923 127.146C151.118 127.634 151.236 128.149 151.273 128.674C151.273 128.803 151.337 128.315 151.54 127.993C151.645 127.68 151.909 127.448 152.232 127.383C152.555 127.318 152.889 127.43 153.106 127.677C153.324 127.925 153.394 128.269 153.289 128.582C153.289 129.18 153.289 129.152 153.289 129.557C153.289 129.962 153.289 130.321 153.289 130.662C153.255 131.201 153.181 131.736 153.068 132.264C152.908 132.73 152.685 133.173 152.405 133.58C151.958 134.077 151.589 134.638 151.31 135.246C151.24 135.548 151.209 135.857 151.218 136.166C151.217 136.452 151.254 136.737 151.328 137.013C150.952 137.053 150.572 137.053 150.196 137.013C149.837 136.958 149.395 136.24 149.275 136.019C149.216 135.9 149.095 135.825 148.962 135.825C148.83 135.825 148.709 135.9 148.65 136.019C148.447 136.369 147.996 137.004 147.683 137.041C147.066 137.114 145.796 137.041 144.793 137.041C144.793 137.041 144.959 136.12 144.581 135.789C144.204 135.458 143.817 135.071 143.532 134.813L142.759 133.93Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.565 134.432V131.255C150.565 131.064 150.411 130.91 150.22 130.91C150.03 130.91 149.875 131.064 149.875 131.255V134.432C149.875 134.622 150.03 134.776 150.22 134.776C150.411 134.776 150.565 134.622 150.565 134.432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.74 134.431L148.722 131.252C148.72 131.062 148.565 130.909 148.374 130.91C148.184 130.911 148.03 131.066 148.031 131.256L148.05 134.435C148.051 134.624 148.206 134.777 148.397 134.776C148.587 134.775 148.741 134.62 148.74 134.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.191 131.259L146.21 134.431C146.211 134.623 146.366 134.777 146.557 134.776C146.748 134.775 146.901 134.619 146.9 134.427L146.882 131.255C146.881 131.063 146.725 130.909 146.535 130.91C146.344 130.911 146.19 131.067 146.191 131.259Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_21716",
    x: 13.4414,
    y: 0.78125,
    width: 217.777,
    height: 217.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "effect1_foregroundBlur_1_21716"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_21716",
    x: 0.78125,
    y: 13.4395,
    width: 217.777,
    height: 217.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36,
    result: "effect1_foregroundBlur_1_21716"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_21716",
    x: 138.911,
    y: 122.607,
    width: 15.6,
    height: 16.6418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_21716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_21716",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodatayet);
export default __webpack_public_path__ + "static/media/nodatayet.c45c147bd60941e7bf8edb0ece5efdfd.svg";
export { ForwardRef as ReactComponent };